var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSettingsCloudColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83922 2.80388C9.9327 2.33646 10.3431 2 10.8198 2H13.1802C13.6569 2 14.0673 2.33646 14.1608 2.80388L14.7087 5.54333C15.2566 5.77347 15.7691 6.07132 16.2356 6.42642L18.8836 5.53065C19.3351 5.3779 19.8317 5.56509 20.0701 5.97791L21.2502 8.02207C21.4886 8.43489 21.4024 8.95855 21.0444 9.27322L18.945 11.1182C18.9813 11.407 19 11.7013 19 12C19 12.2987 18.9813 12.593 18.945 12.8818L21.0444 14.7268C21.4024 15.0414 21.4886 15.5651 21.2502 15.9779L20.0701 18.0221C19.8317 18.4349 19.3351 18.6221 18.8836 18.4694L16.2356 17.5736C15.7691 17.9287 15.2566 18.2265 14.7087 18.4567L14.1608 21.1961C14.0673 21.6635 13.6569 22 13.1802 22H10.8198C10.3431 22 9.9327 21.6635 9.83922 21.1961L9.29133 18.4567C8.74337 18.2265 8.23088 17.9287 7.76432 17.5735L5.11629 18.4693C4.66474 18.6221 4.16815 18.4349 3.92981 18.0221L2.74962 15.9779C2.51128 15.5651 2.59745 15.0414 2.95551 14.7268L5.05499 12.8817C5.01869 12.5929 4.99999 12.2986 4.99999 12C4.99999 11.7014 5.01869 11.4071 5.05499 11.1183L2.95551 9.27324C2.59745 8.95856 2.51128 8.43491 2.74962 8.02209L3.92981 5.97793C4.16815 5.56511 4.66474 5.37791 5.11629 5.53066L7.76432 6.42646C8.23088 6.07135 8.74337 5.77348 9.29133 5.54333L9.83922 2.80388ZM15 12C15 13.6569 13.6568 15 12 15C10.3431 15 8.99999 13.6569 8.99999 12C8.99999 10.3431 10.3431 9 12 9C13.6568 9 15 10.3431 15 12Z",
    fill: "url(#paint0_linear_1136_13145)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z",
    fill: "#2C6E49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22C10.6789 22 9 20.3211 9 18.25C9 16.1789 10.6789 14.5 12.75 14.5C12.7646 14.5 12.7792 14.5001 12.7938 14.5003C13.6583 13.0056 15.2742 12 17.125 12C19.727 12 21.8648 13.9876 22.103 16.5274C23.1122 16.8746 23.8618 17.7801 23.9828 18.875H24C24 18.9288 23.9986 18.9823 23.996 19.0354C23.9986 19.0857 24 19.1365 24 19.1875C24 20.7408 22.7408 22 21.1875 22H12.75Z",
    fill: "url(#paint1_linear_1136_13145)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15L14 19H16L16 22H18V19L20 19L17 15Z",
    fill: "#FDCA35"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_13145",
    x1: 2,
    y1: 2,
    x2: 22.5,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C956C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_13145",
    x1: 9,
    y1: 13,
    x2: 24,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C25EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSettingsCloudColored);
export default __webpack_public_path__ + "static/media/ic_action_settings_cloud_colored.becdd572d0c8028390e3b03848c39aef.svg";
export { ForwardRef as ReactComponent };